import { MenuItem } from "@blueprintjs/core"
import { ItemRenderer, Suggest } from "@blueprintjs/select"
import { useState } from "react"
import useInstruments from "../hooks/useInstruments"
import { InstrumentLight } from "../pages/Config/types"

interface InstrumentSuggestProps {
  selectedInstrument: InstrumentLight | null
  onInstrumentSelect: (instrument: InstrumentLight) => void
  placeholder?: string
}

/**
 * Suggest component to select an instrument from the trading instruments list.
 * Only fetches when user starts typing.
 */
const InstrumentSuggest = ({
  selectedInstrument,
  onInstrumentSelect,
  placeholder = "Search for instrument",
}: InstrumentSuggestProps) => {
  const [query, setQuery] = useState("")
  const { instruments } = useInstruments(query)

  const renderInstrument: ItemRenderer<InstrumentLight> = (instrument, { handleClick, modifiers }) => {
    return (
      <MenuItem
        active={modifiers.active}
        key={instrument.id}
        onClick={handleClick}
        text={instrument.bloomberg_code}
        label={instrument.type}
      />
    )
  }

  const noResults = (
    <MenuItem
      active={false}
      disabled={true}
      icon="zoom-out"
      text={query.length === 0 ? "Type to search instruments" : "No instruments found"}
    />
  )

  return (
    <Suggest<InstrumentLight>
      items={instruments ?? []}
      inputValueRenderer={(instrument: InstrumentLight) => instrument.bloomberg_code}
      itemRenderer={renderInstrument}
      onItemSelect={onInstrumentSelect}
      onQueryChange={setQuery}
      noResults={noResults}
      fill={true}
      inputProps={{ placeholder }}
      selectedItem={selectedInstrument}
      resetOnSelect={true}
    />
  )
}

export default InstrumentSuggest
